import { Trans, useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function VerifiedIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      className={props.className}
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t`Verified Collection Icon`}</title>
      <g id="Frame">
        <path
          id="Vector"
          d="M1.62275 9.04447C1.62214 9.52343 1.73735 9.8779 1.96836 10.108C2.19877 10.3386 2.54836 10.4521 3.01712 10.4484H4.06036C4.10395 10.4468 4.14742 10.4541 4.18809 10.4698C4.22876 10.4856 4.2658 10.5095 4.29688 10.5401L5.03946 11.2742C5.37682 11.6113 5.70744 11.7789 6.03135 11.7771C6.35527 11.7753 6.68591 11.6077 7.02327 11.2742L7.75671 10.5401C7.78887 10.5092 7.82695 10.485 7.86871 10.4693C7.91047 10.4535 7.95503 10.4464 7.99959 10.4484H9.03647C9.51007 10.449 9.86303 10.3337 10.0953 10.1025C10.3275 9.87119 10.4437 9.51671 10.4437 9.03895V8.0011C10.4413 7.91118 10.4742 7.8239 10.5353 7.75791L11.2687 7.02383C11.6104 6.68798 11.78 6.35734 11.7775 6.0319C11.7751 5.70642 11.6055 5.37546 11.2687 5.03901L10.5353 4.3049C10.474 4.23907 10.4411 4.1517 10.4437 4.06174V3.0239C10.443 2.54551 10.3278 2.19101 10.0981 1.96038C9.86823 1.72975 9.51439 1.61443 9.03647 1.61443H7.99959C7.95503 1.61627 7.91055 1.60909 7.86879 1.59333C7.82711 1.57756 7.78895 1.55353 7.75671 1.52267L7.02327 0.788576C6.68591 0.451496 6.35527 0.283881 6.03135 0.285721C5.70744 0.287553 5.37682 0.455168 5.03946 0.788576L4.29688 1.52267C4.2657 1.55317 4.22868 1.57702 4.18802 1.59279C4.14737 1.60856 4.10393 1.61593 4.06036 1.61443H3.01712C2.54408 1.61505 2.19235 1.72944 1.96194 1.95762C1.73153 2.18581 1.61632 2.54123 1.61632 3.0239V4.06449C1.6189 4.15446 1.58596 4.24182 1.52465 4.30766L0.791261 5.04176C0.454509 5.37761 0.286133 5.70856 0.286133 6.03462C0.286133 6.3607 0.456653 6.69222 0.797685 7.02935L1.53108 7.76342C1.59222 7.82934 1.62512 7.91662 1.62275 8.00662V9.04447Z"
          fill="#FAFF00"
        />
        <path
          id="Vector_2"
          d="M5.99848 7.9954C5.89023 8.16036 5.73043 8.25308 5.54484 8.25308C5.35412 8.25308 5.20462 8.1758 5.06544 7.9954L3.84888 6.51076C3.76124 6.40252 3.71484 6.28908 3.71484 6.1654C3.71484 5.90763 3.91073 5.70658 4.16332 5.70658C4.31797 5.70658 4.44169 5.76328 4.56541 5.92309L5.52423 7.14484L7.56043 3.87658C7.66867 3.70132 7.80787 3.61884 7.96251 3.61884C8.20483 3.61884 8.43163 3.78895 8.43163 4.04154C8.43163 4.1601 8.36979 4.28382 8.30275 4.39208L5.99848 7.9954Z"
          fill="#0A0A0A"
        />
      </g>
    </svg>
  )
}
